export const general = {
	fieldsAddress: {
		cep: {
			label: "Código postal",
			placeholder: "00000-000",
		},
		complement: {
			label: "Complemento",
			placeholder: "Ingresar complemento",
		},
		county: {
			label: "Municipio",
			placeholder: "Ingresar municipio",
		},
		neighborhood: {
			label: "Colonia",
			placeholder: "Ingresar colonia",
		},
		number: {
			label: "Número",
			placeholder: "Ingresar número",
		},
		publicplace: {
			label: "Calle",
			placeholder: "Ingresar calle",
		},
		uf: {
			label: "Estado",
			placeholder: "Seleccionar estado",
		},
	},
	fieldsGeneral: {
		email: {
			label: "Email",
			placeholder: "Ingresar email",
		},
		fiscalMode: {
			label: "Modo fiscal",
			placeholder: "Seleccionar modo fiscal",
		},
		enableManifestation: {
			label:
				"Habilitar búsqueda de facturas emitidas para este RFC para importación en stock",
		},
		name: {
			label: "Nombre",
			placeholder: "Nombre del perfil",
		},
		phone: {
			label: "Teléfono",
			placeholder: "Ingresar teléfono",
			error: "Teléfono inválido: debe contener de 10 a 11 dígitos con LADA",
			errorIvaVendus: "Teléfono inválido: debe contener 9 dígitos",
			errorIvaFactura: "Teléfono inválido: debe contener de 9 a 12 dígitos",
		},
	},
	optionsFiscalMode: {
		ivaFactura: "IVA - Factura",
		ivaVendus: "IVA - Vendus",
		nfce: "NFC-e",
		sat: "SAT",
	},
	optionsEnableManifestation: {
		allow: "Sí, permitir búsqueda de facturas emitidas para este RFC",
		notAllow: "No permitir búsqueda de facturas",
	},
};
